module.exports = __webpack_public_path__ + "static/img/4-2.0664490.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/case/4-2.png
// module id = QJZh
// module chunks = 0